import { useState } from "react"
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes"
import { Box, Tab, Tabs } from "@mui/material"
import TabPanel from "../ui/TabPanel"
import { Assignments } from "./Assignments"
import { Exams } from "./Exams"

export const Submissions = ({tab}) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    switch(newValue) {
      case 0:
        navigate(routes.CLASSES.ASSIGNMENTS, {replace: true})
        break
      case 1:
        navigate(routes.CLASSES.EXAMS, {replace: true})
        break
      default:
        navigate(routes.CLASSES.ASSIGNMENTS, {replace: true})
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: "#f8f8f8",
        display: "flex",
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        style={{ paddingTop: "1rem", width: "15rem" }}
      >
        <Tab
          style={{ background: value === 0 ? "white" : "" }}
          label="Assignments"
        />
        <Tab label="Exams" style={{ background: value === 1 ? "white" : "" }} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <Assignments />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Exams />
      </TabPanel>
    </Box>
  )
}
